import { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import './adventure.css';
import Symptoms from './components/Symptoms';
import FirstAid from './components/FirstAid';

export default function Child() {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('signs');
  const renderContent = (tab) => {
    switch (tab) {
      case 'firstAid':
        return <FirstAid />;
      default:
        return <Symptoms />;
    }
  };
  return (
    <div className="child__container">
      <div className="child__header">
        <h2 className="child__title">{t('staticPages.homePageChild.title')}</h2>
        <p className="child__subTitle">{t('staticPages.homePageChild.subtitle')}</p>
        <Tabs activeTab={activeTab} setActiveTab={setActiveTab} />
      </div>
      {renderContent(activeTab)}
    </div>
  );
}

function Tabs({ activeTab, setActiveTab }) {
  const { t } = useTranslation();
  const tabs = [
    { id: 'signs', label: t('staticPages.homePageChild.tabs.signs'), style: 'tab__signs' },
    { id: 'firstAid', label: t('staticPages.homePageChild.tabs.firstAid'), style: 'tab__firstAid' },
  ];

  const renderTabs = tabs.map((tab) => {
    const isActive = activeTab === tab.id;
    return (
      <button
        key={tab.id}
        type="button"
        className={`tab__item ${isActive ? tab.style : ''}`}
        onClick={() => setActiveTab(tab.id)}
      >
        {tab.label}
      </button>
    );
  });

  return <div className="tab__container">{renderTabs}</div>;
}

Tabs.propTypes = {
  activeTab: PropTypes.string.isRequired,
  setActiveTab: PropTypes.func.isRequired,
};
